import { render, staticRenderFns } from "./product-select-table.vue?vue&type=template&id=735646b8&"
import script from "./product-select-table.vue?vue&type=script&lang=js&"
export * from "./product-select-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports